<template>
  <div class="skipped-offer">
    <div class="row">
      <div class="d-none d-lg-block col-lg-3 skipped-logo"><img :src="logoURL" v-if="logoURL" /></div>
      <div class="col-10 col-lg-7 skipped-title" v-if="!reason">{{title}}</div>
      <template v-else>
        <div class="col-7 col-lg-5 skipped-title">{{title}}</div>
        <div class="col-5 col-lg-4 skipped-reason">{{reason}}</div>
      </template>
      <div class="col-2" v-if="reason !== 'A similar offer has been submitted'"><button class="btn btn-danger unskip" @click="unskip" :disabled="waitingOnOffers">x</button></div>
    </div>
    <div class="row">
      <div class="col-auto offer-subject" v-for="subject in subjects" :key="subject.id">{{subject.name}}</div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'SkippedOffer',
  props: ['offer'],
  emits: ['unskipOffer'],
  components: {
  },
  data () {
    return {
    }
  },
  computed: {
    logoURL () {
      return this.offer.logoURL
    },
    title () {
      return this.offer.name
    },
    subjects () {
      return this.offer.subjects
    },
    reason () {
      return this.offer.skipReason
    },
    ...mapState({
      waitingOnOffers: state => state.consumer.waitingOnOffers
    })
  },
  methods: {
    unskip () {
      this.$emit('unskipOffer', this.offer)
    }
  }
}
</script>

<style scoped>
.skipped-offer {
  padding-top: 10px;
}
.skipped-logo img {
  max-width: 100%;
  max-height: 45px;
  width: auto;
  height: auto;
}
.unskip {
  float: right;
}
</style>
